export const SIGN_UP_LOAD = 'signup_visit';
export const SIGN_UP_COMPLETE = 'sign_up';
export const EMAIL_VERIFIED = 'email_verified';
export const PLAN_SELECTED = 'plan_selected';
export const PROJECT_CREATED = 'project_created';
export const AUDIO_GENERATED = 'audio_generated';
export const AUDIO_DOWNLOADED = 'audio_downloaded';
export const ONBOARDING_STARTED = 'onboarding_started';
export const ONBOARDING_STEP_COMPLETED = 'onboarding_step_completed';
export const ONBOARDING_COMPLETED = 'onboarding_completed';
